import { EquipmentStatusCategoryOptions } from '@models/EquipmentStatus.model';
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 16px;
  width: 100%;
  position: relative;
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
`;

export const Text = styled.div`
  color: #474d66;
  font-size: 14px;
  font-weight: 500;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
`;

export const StatusIcon = styled.div`
  height: 20px;
  overflow: hidden;
`;

export const StatusText = styled.div`
  color: #1b203a;
  font-size: 14px;
  font-weight: 500;
  margin-left: 9px;
`;

export const ArrowDown = styled.div`
  margin-left: 20px;
  height: 20px;
  overflow: hidden;
`;

export const LineOverflow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const Block = styled.div`
  width: calc(100% + 32px + 2px);
  position: absolute;
  top: -13px;
  left: -17px;
  padding: 12px 16px 16px 16px;
  border-radius: 4px;
  box-shadow: 0px 6px 10px rgba(33, 39, 73, 0.12);
  border: 1px solid #edeff4;
  background: #fff;
  z-index: 10;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e6e8f0;
  margin-top: 16px;
`;

export const BlockText = styled.div`
  color: #1b203a;
  font-size: 14px;
  font-weight: 500;
  margin-top: 16px;
`;

export const Label = styled.div`
  color: #8f95b2;
  font-size: 12px;
  font-weight: 500;
  margin-top: 16px;
`;

export const TextArea = styled.textarea`
  color: #8f95b2;
  font-size: 14px;
  font-weight: 400;
  border-radius: 8px;
  border: 1px solid #d8dae5;
  margin-top: 8px;
  padding: 10px 16px;
  min-height: 80px;
  max-height: 180px;
  background: #fff;
  width: 100%;
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 12px;
  margin-bottom: 10px;
`;

export const Cancel = styled.button`
  color: #474d66;
  font-weight: 500;
  font-size: 14px;
  background: none;
  border: none;
  outline: 0;
`;

export const Done = styled.button`
  color: ${({ disabled }) => (disabled ? '#C1C4D6' : '#1371FE')};
  font-weight: 500;
  font-size: 14px;
  margin-left: 40px;
  margin-right: 16px;
  background: none;
  border: none;
  outline: 0;
`;

export const Comment = styled.div`
  color: #474d66;
  font-size: 14px;
  font-weight: 400;
  margin-top: 16px;
`;

export const LastChanged = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
`;

export const LastChangedText = styled.div`
  color: #474d66;
  font-size: 12px;
  font-weight: 400;
`;

export const Avatar = styled.img`
  height: 16px;
  width: 16px;
  object-fit: cover;
  margin-left: 8px;
  border-radius: 8px;
`;

export const LastChangedDate = styled.div`
  color: #474d66;
  font-size: 12px;
  font-weight: 400;
  margin-left: 8px;
`;

export const Empty = styled.div`
  color: #8f95b2;
  font-size: 14px;
  font-weight: 400;
  text-align: end;
  font-style: italic;
`;

interface IStatusBadge {
  category: EquipmentStatusCategoryOptions;
}

export const StatusBadge = styled.div<IStatusBadge>`
  width: 14px;
  height: 14px;
  border-radius: 7px;
  border: 3px solid
    ${({ category }) => {
      if (category === 'Online') return '#dcf2ea';
      if (category === 'Offline') return '#ffefd2';
      return '#e6e8f0';
    }};
  background-color: ${({ category }) => {
    if (category === 'Online') return '#52bd94';
    if (category === 'Offline') return '#ff9900';
    return '#8f95b2';
  }};
`;
